import { Navigate, useParams } from 'react-router-dom'
import { STAFF_ROUTE } from '../../app/router/routes'

export default function AdminPage() {
    const {id} = useParams<{id: string}>()

    return <Navigate to={id ? `${STAFF_ROUTE.path}/${id}` : STAFF_ROUTE.path} replace />
}
